import Image from "next/legacy/image";
import React, { useState } from "react";
import { HintText } from "../edit-userdata/edit-userdata.styles";
import {
  FormGroup,
  IconWrapper,
  InputWrapper,
  Label,
  StyledInput,
  SuggestionItem,
  SuggestionList,
  SuggestionWarningItem
} from "./form-group.styles";
import { FormGroupFieldProps } from "./form-group.types";

export const FormGroupField: React.FC<FormGroupFieldProps> = ({
  label,
  placeholder,
  value,
  changeHandler,
  options,
  isCustom = false,
  activeIcon,
  inactiveIcon,
  notFoundMessage,
  errorMessage,
  margin,
  isSchoolField
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [isSelectedFromDropdown, setIsSelectedFromDropdown] = useState(false);

  const handleInputChange = (val: string) => {
    changeHandler(val);
    setIsSelectedFromDropdown(false);
  };

  const handleSelectOption = (val: string) => {
    changeHandler(val);
    setIsSelectedFromDropdown(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
    if (isSchoolField && isCustom && !isSelectedFromDropdown) {
      changeHandler("");
    }
  };

  return (
    <FormGroup style={{ margin }}>
      <Label>{label}</Label>
      <InputWrapper>
        <StyledInput
          type="text"
          placeholder={placeholder}
          value={value}
          onFocus={() => setIsFocused(true)}
          onBlur={handleBlur}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            handleInputChange(e.target.value)
          }
          hasError={!!errorMessage}
        />

        <IconWrapper>
          <Image
            src={isFocused ? activeIcon : inactiveIcon}
            width="20"
            height="20"
            alt={isFocused ? "active-icon" : "inactive-icon"}
          />
        </IconWrapper>
      </InputWrapper>

      {isFocused && (options.length > 0 || isCustom) && (
        <SuggestionList>
          {options.map((item) => (
            <SuggestionItem
              key={item.id}
              onMouseDown={() => handleSelectOption(item.name)}
            >
              {item.name}
            </SuggestionItem>
          ))}

          {notFoundMessage && isCustom && (
            <>
              <SuggestionWarningItem>{notFoundMessage}</SuggestionWarningItem>

              <SuggestionItem
                key="custom-entry"
                onMouseDown={() => handleSelectOption(value)}
              >
                <span style={{ color: "#72839E" }}>Lanjutkan pakai</span> &apos;
                {value}&apos;
              </SuggestionItem>
            </>
          )}
        </SuggestionList>
      )}
      {errorMessage && (
        <HintText isError={!!errorMessage}>{errorMessage}</HintText>
      )}
    </FormGroup>
  );
};
